import { render, staticRenderFns } from "./VisualizacaoEmLista.vue?vue&type=template&id=67561bc6"
import script from "./VisualizacaoEmLista.vue?vue&type=script&lang=js"
export * from "./VisualizacaoEmLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports